import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccountContext } from "../../Contexts/main.context";
import lgologo from '../../assets/SVG/LGO.svg';
import ClientViewLocations from "./clientLocationList.component";
import ShowClientTheirCitations from "./clientCitationsList.component";

const ClientDashboard = () => {
    const { activeClient } = useContext(AccountContext);
    const [view, setView] = useState('locations');
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("LGOUser");
        navigate("/login");
    };

    if (!activeClient) {
        return <div className="text-center mt-5">No client selected</div>;
    }

    return (
        <div className="container-fluid p-0 position-relative min-vh-100 d-flex flex-column">
            <nav className="bg-navy text-white py-2 px-3 d-flex align-items-center gap-2 justify-content-between">
                <div className="d-flex align-items-center gap-3">
                    <img src={lgologo} alt="LGO Logo" style={{ height: '45px' }} />
                </div>
                <div className="btn-group d-flex gap-2">
                    <button
                        className={`btn btn-sm ${view === 'locations' ? 'btn-warning' : 'btn-outline-light'}`}
                        onClick={() => setView('locations')}
                    >
                        Locations
                    </button>
                    <button
                        className={`btn btn-sm ${view === 'citations' ? 'btn-warning' : 'btn-outline-light'}`}
                        onClick={() => setView('citations')}
                    >
                        Citations
                    </button>
                </div>
            </nav>

            <div className="flex-grow-1 overflow-auto p-3">
                {view === 'locations' && <ClientViewLocations setView={setView} />}
                {view === 'citations' && <ShowClientTheirCitations />}
            </div>

            <div className="w-100 p-3 bg-light border-top">
                <button className="btn btn-danger col-24 offset-12" onClick={handleLogout}>
                    Log Out
                </button>
            </div>
        </div>
    );
};

export default ClientDashboard;
